import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";
import Modal from "react-modal";

Modal.setAppElement("#root");

const CateringSuperImageCard = ({ setShowLogin, combo }) => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const userId = localStorage.getItem("userId");

  const closeModal = () => setIsModalOpen(false);

  const goToCart = () => {
    setIsModalOpen(false);
    navigate("/cartsdata");
  };

  const increaseQuantity = async () => {
    if (!userId) return setShowLogin(true);
    const newQuantity = quantity + 1;
    const apiUrl = ` https://backend.maamaas.com/food/api/cart/update/${userId}?quantity=${newQuantity}&dishId=${combo.dishId}`;
    try {
      await axios.put(apiUrl, null, { headers: { accept: "*/*" } });
      setQuantity(newQuantity);
    } catch (err) {
      console.error("Failed to increase quantity", err);
      alert(err.response?.data?.message || "Unable to add item right now.");
    }
  };

  const decreaseQuantity = async () => {
    if (!userId) return setShowLogin(true);
    if (quantity <= 1) return;
    const newQuantity = quantity - 1;
    const apiUrl = ` https://backend.maamaas.com/food/api/cart/update/${userId}?quantity=${newQuantity}&dishId=${combo.dishId}`;
    try {
      await axios.put(apiUrl, null, { headers: { accept: "*/*" } });
      setQuantity(newQuantity);
    } catch (err) {
      console.error("Failed to decrease quantity", err);
      alert(err.response?.data?.message || "Unable to decrease quantity right now.");
    }
  };

  const addToCart = async () => {
    if (!userId) {
      setShowLogin(true);
      return;
    }
    if (quantity === 0) setQuantity(1);

    const apiUrl = ` https://backend.maamaas.com/food/api/cart/add/${userId}?orderType=DINE_IN`;
    const data = { dishId: combo.dishId, quantity: quantity || 1 };

    try {
      const response = await axios.post(apiUrl, data, {
        headers: { "Content-Type": "application/json" },
      });
      if (response.status === 200) {
        setIsModalOpen(true);
        setTimeout(() => {
          if (!hovered) setIsModalOpen(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Error adding item to cart:", error);
      alert("Something went wrong, please try again.");
    }
  };

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: 8,
        outline: "none",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          height: 360,
          width: 360,
          borderRadius: 16,
          overflow: "hidden",
          position: "relative",
          background: "#000",
          boxShadow: hovered
            ? "0 16px 30px rgba(0,0,0,0.25)"
            : "0 12px 25px rgba(0,0,0,0.1)",
          transform: hovered ? "scale(1.03)" : "scale(1)",
          transition: "all .3s",
          cursor: "pointer",
        }}
      >
        <img
          src={combo.dishImage}
          alt={combo.dishName || combo.title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        />

        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.45)",
            zIndex: 2,
          }}
        />

        <div
          style={{
            position: "absolute",
            inset: 0,
            padding: 16,
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            zIndex: 3,
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                background: "linear-gradient(90deg, #ff5722, #e91e63)",
                color: "#fff",
                fontSize: 14,
                fontWeight: "600",
                padding: "6px 14px",
                borderRadius: "20px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              }}
            >
              🎉 {combo.discount}% OFF
            </div>
          </div>

          <div style={{ flex: 1 }} />

          <div>
            <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>
              {combo.dishName || combo.title}
            </h3>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                style={{
                  background: "green",
                  padding: "6px 12px",
                  borderRadius: 6,
                  fontWeight: "bold",
                  fontSize: 16,
                  color: "#fff",
                  whiteSpace: "nowrap",
                }}
              >
                ₹{combo.price || 199}
              </div>

              <button
                onClick={addToCart}
                style={{
                  padding: "8px 14px",
                  backgroundColor: "rgb(177 92 214)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  fontWeight: "bold",
                  cursor: "pointer",
                  flex: 1,
                  transition: "background .3s",
                }}
              >
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Add to Cart"
        style={{
          overlay: { backgroundColor: "transparent" },
          content: {
            position: "absolute",
            top: "90%",
            left: "50%",
            height: "100px",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "500px",
            border: "none",
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            padding: "20px",
            borderRadius: "10px",
            background: "#fff",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            width: "100%",
          }}
        >
          <button
            onClick={goToCart}
            style={{
              background: "rgb(177 92 214)",
              border: "none",
              borderRadius: "50%",
              width: "45px",
              height: "45px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <FaShoppingCart style={{ color: "#fff", fontSize: 20 }} />
          </button>

          <h3 style={{ margin: 0, fontSize: 18, fontWeight: "bold", flex: 1 }}>
            {combo.dishName || combo.title}
          </h3>

          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <button
              onClick={decreaseQuantity}
              style={{
                width: "35px",
                height: "35px",
                borderRadius: "50%",
                border: "none",
                background: "#eee",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              -
            </button>
            <span style={{ fontSize: "16px" }}>{quantity}</span>
            <button
              onClick={increaseQuantity}
              style={{
                width: "35px",
                height: "35px",
                borderRadius: "50%",
                border: "none",
                background: "#eee",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              +
            </button>
          </div>

          <div style={{ fontSize: 16, fontWeight: "bold" }}>
            ₹{(combo.price || 199) * quantity}
          </div>

          <button
            style={{
              borderRadius: "50px",
              background: "#ee6521",
              color: "#fff",
              padding: "8px 16px",
              border: "none",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
            onClick={goToCart}
          >
            View Cart
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default function CateringSuperOffer() {
  const [combosData, setCombosData] = useState([]);
  const [vendorId, setVendorId] = useState(null);

  useEffect(() => {
    const id = localStorage.getItem("vendorId");
    if (id) setVendorId(id);
  }, []);

  useEffect(() => {
    if (!vendorId) return;

    const fetchCombos = async () => {
      try {
        const token = localStorage.getItem("authToken");

        const response = await axios.get(
          ` https://backend.maamaas.com/food/dish/getbyvendor/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const filteredData = response.data.filter((item) => item.parentId !== 0);
        setCombosData(filteredData);
      } catch (error) {
        console.error("❌ Error fetching combos:", error);
      }
    };

    fetchCombos();
  }, [vendorId]);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: "linear",
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section
      className="combos-wrapper"
      style={{ maxWidth: 999, margin: "0 auto", padding: "0px 20px" }}
    >
      <h1
        style={{
          textAlign: "center",
          fontSize: 38,
          fontWeight: 800,
          letterSpacing: 1,
          textTransform: "uppercase",
          textShadow: "0 4px 6px rgba(0,0,0,.1)",
          margin: "0 0 20px",
        }}
      >
        <span style={{ color: "rgb(42 9 71)" }}></span>
        <span style={{ color: "red" }}>Flat</span> Offers
      </h1>

      <Slider {...settings}>
        {combosData.length > 0 ? (
          combosData.map((combo) => <CateringSuperImageCard key={combo.id} combo={combo} />)
        ) : (
          <p style={{ textAlign: "center", width: "100%" }}>Loading combos...</p>
        )}
      </Slider>
    </section>
  );
}